<script>
  export let content = "";
  export let label = "";
</script>

<style>
  div#box {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 8px;
  }
  textarea#box {
    height: 14vh;
    resize: vertical;
    min-height: 14vh;
    color: #444;
  }
  label {
    font-size: 1.2rem;
  }
  @media (max-width: 992px) {
    div#box {
      grid-template-rows: 40px 1fr;
    }
  }
</style>

<div id="box">
  <label for="box">{label}</label>
  <textarea readonly bind:value={content} id="box" on:input />
</div>
